var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import * as cookies from 'tiny-cookie';
import { set, event } from 'vue-analytics';
import urls from "../../urls";
export default {
    namespaced: true,
    state: {
        'id': '',
        'username': '',
        'isStaff': false,
    },
    mutations: {
        setUser(state, payload) {
            state.id = payload.pk;
            state.username = payload.username;
            state.isStaff = payload.is_staff || payload.isStaff || false;
        },
        resetUser(state, payload) {
            state.id = '';
            state.username = '';
            state.isStaff = false;
        },
    },
    actions: {
        getUser(context) {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                try {
                    if (localStorage.getItem('Token')) {
                        axios.defaults.headers.common['Authorization'] = "Token " + localStorage.getItem('Token');
                    }
                    let response = yield axios.get(urls['account']);
                    let data = response.data;
                    context.commit('setUser', data);
                    axios.defaults.headers.common['X-CSRFTOKEN'] = cookies.get('csrftoken');
                    set("userId", context.state.id);
                    resolve();
                }
                catch (error) {
                    reject(error);
                }
            }));
        },
        login: (context, payload) => new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
            try {
                axios.defaults.headers.common['Authorization'] = '';
                let response = yield axios.post(urls['login'], {
                    'username': payload[0],
                    'password': payload[1],
                });
                if (typeof (response.data['key']) !== "string") {
                    reject({ 'detail': 'Server sent invalid data' });
                }
                localStorage.setItem('Token', response.data['key']);
                event('userAction', 'login');
                yield context.dispatch('getUser');
                resolve();
            }
            catch (error) {
                reject(error.response.data);
            }
        })),
        logout: (context) => new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
            try {
                yield axios.post(urls['logout']);
                localStorage.removeItem('Token');
                context.commit('resetUser');
                event('userAction', 'logout');
                set("userId", -1);
                resolve();
            }
            catch (error) {
                resolve();
            }
        })),
    },
    getters: {
        isLoggedIn: state => {
            return Boolean(state.username);
        }
    }
};
